export default __webpack_public_path__ + "static/media/041-itsukushima shrine.b2453826.svg";